import { Typography, Paper, Stack, Checkbox, Box, TextField, Button } from "@mui/material";
import { ScheduleType } from "../../../types/schedule.types";

interface EmergencyOptionsProps {
    value: any;
    setFieldValue: (field: string, value: any) => void;
    phoneErrors: string[]
    nameErrors: string[]
    handleContactChange: (index: number, field: "full_name" | "phone_number", valueStr: string) => void
    isEdit: boolean
    teamId?: string
    selectedSchedule?: ScheduleType.Model | null
    setViewSchedule: React.Dispatch<React.SetStateAction<boolean>>
}

export const EmergencyOptions: React.FC<EmergencyOptionsProps> = ({
  value,
  setFieldValue,
  phoneErrors,
  nameErrors,
  handleContactChange,
  isEdit,
  selectedSchedule,
  setViewSchedule,
}) => {
  const isDisabled = value?.checkOnMeEnabled === false;

  return value ? (
    <>
      <Typography fontSize={16} variant="body1" mt={4} fontWeight={500} color={"text.default"}>
        Check on Me - Alert Escalation Setup (Optional)
        {/* <Typography color="error" component="span">*</Typography> */}
      </Typography>

      {/* Default Contact Option */}
      <Paper
        elevation={1}
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: "#f7f7f7",
          mb: 2,
          opacity: isDisabled ? 0.6 : 1,
          pointerEvents: isDisabled ? "none" : "auto",
        }}
      >
        <Stack direction="row" alignItems="flex-start" spacing={2}>
          <Checkbox
            checked={value.defaultContact ?? false}
            onChange={() => {
              const newVal = !(value.defaultContact ?? false);
              setFieldValue("settings.defaultContact", newVal);
            }}
            sx={{ mt: 0.5 }}
          />
          <Box>
            <Typography fontWeight={600}>Set List of Emergency Contact(s)</Typography>
            <Typography variant="body2" color="textSecondary">
                Define up to 2 contacts that will be notified by POM Dispatch if a 'Check on Me' escalation occurs.
                These contacts will work with Dispatch to decide next steps when Dispatch is unable to connect with the POM User.
            </Typography>
            <Typography variant="body2" color="textSecondary" fontWeight={600} mt={1}>
                NOTE:{" "}
                <Typography component="span" variant="body2" color="textSecondary">
                    Adding Contacts means Dispatch will always contact these individuals before dispatching help.
                </Typography>
            </Typography>
          </Box>
        </Stack>

        {(value.defaultContact ?? false) && (
          <Box mt={2}>
            {[0, 1].map((i) => (
              <Box key={i} mb={2}>
                <Typography fontWeight={600}>{`Contact ${i + 1}:`}</Typography>
                <Stack direction="row" spacing={2} alignItems="center" mt={1}>
                  <TextField
                    label="Full Name"
                    value={value.contacts?.[i]?.full_name || ""}
                    onChange={(e) => handleContactChange(i, "full_name", e.target.value)}
                    fullWidth
                    error={!!nameErrors[i]}
                    helperText={nameErrors[i]}
                  />
                  <TextField
                    label="Phone Number"
                    value={value.contacts?.[i]?.phone_number || ""}
                    onChange={(e) => handleContactChange(i, "phone_number", e.target.value)}
                    fullWidth
                    error={!!phoneErrors[i]}
                    helperText={phoneErrors[i]}
                  />
                </Stack>
              </Box>
            ))}
          </Box>
        )}
      </Paper>

      {/* Calendar Option */}
      <Paper
        elevation={1}
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: "#f7f7f7",
          opacity: isDisabled ? 0.6 : 1,
          pointerEvents: isDisabled ? "none" : "auto",
        }}
      >
        <Stack direction="row" alignItems="flex-start" spacing={2}>
          <Checkbox
            checked={value.calendarEnabled ?? false}
            onChange={() => {
              const newVal = !(value.calendarEnabled ?? false);
              setFieldValue("settings.calendarEnabled", newVal);
            }}
            sx={{ mt: 0.5 }}
          />
          <Box>
            <Typography fontWeight={600}>Calendar</Typography>
            <Typography variant="body2" color="textSecondary">

              { (((value.calendarEnabled ?? false) && selectedSchedule != null ) || !(value.calendarEnabled ?? false))  ? 'For enhanced configurability, you can create a calendar in addition to your two default emergency contacts. This lets you designate different contacts for specific time blocks, ensuring the right people are alerted based on availability.' : 'You will be prompted to create the calendar after you save the team'}
            </Typography>
          </Box>
        </Stack>

        {isEdit && (value.calendarEnabled ?? false) && selectedSchedule != null && (
          <Button
            variant="outlined"
            onClick={() => {
              setViewSchedule(true);
            }}
          >
            Update Calendar
          </Button>
        )}
      </Paper>
    </>
  ) : <div></div>;
};

export default EmergencyOptions;
